import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import { initializeApp, getApps } from 'firebase/app';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class FirebaseStorageService {
  constructor() {
    if (!getApps().length) {
      initializeApp(environment.firebase);
    }
  }

  resolve(gsUrl: string): Observable<string> {
    const storage = getStorage();
    const path = gsUrl.replace('gs://', '');
    const refPath = path.substring(path.indexOf('/') + 1);
    const storageRef = ref(storage, refPath);
    return from(getDownloadURL(storageRef));
  }
}
